import Button from "app/components/UI/Button";
import Icon from "app/components/UI/Icon";
import Link from "app/components/UI/Link";
import React from "react";
import Spinner from "app/components/UI/Spinner";
import Title from "app/components/UI/Title";
import classes from "../CheckoutLayout/CheckoutLayout.module.css";

export const CheckoutResponse = ({ translate, invoiceData, messageState, intl, isLoading, onInvoicePrint }) => (
  <div className={classes.container_lite}>
    <Title component="h2">{messageState}</Title>
    {isLoading ? (
      <Spinner absolute />
    ) : (
      <div>
        {invoiceData["paymentsStatus"] === "paid" || invoiceData["paymentsStatus"] === "pending" ? (
          <div>
            <Button primary label={translate("Imprimer la facture")} onClick={onInvoicePrint}>
              <Icon className={classes.icon_print}>print</Icon>
            </Button>
            <h3>{translate("Résumé de votre panier")}</h3>

            <ul className={classes.item_response}>
              {Object.keys(invoiceData).length > 0 &&
                invoiceData.lines.map(item => (
                  <li key={item["@id"]}>
                    <p className={classes.name}>{item["name"]}</p>
                    <p className={classes.price}>
                      {intl.formatNumber(item["priceTI"] / 100, {
                        style: "currency",
                        currency: item["priceCurrency"]
                      })}
                    </p>
                  </li>
                ))}
            </ul>
            <h2 className={classes.total_price}>
              <b>
                {intl.formatNumber(invoiceData["totalTI"] / 100, {
                  style: "currency",
                  currency: invoiceData["priceCurrency"]
                })}
              </b>{" "}
              {translate("Total TTC")}
            </h2>
            <p>
              <b>
                {intl.formatNumber(invoiceData["totalTE"] / 100, {
                  style: "currency",
                  currency: invoiceData["priceCurrency"]
                })}
              </b>{" "}
              {translate("HT")}
            </p>
            {Object.entries(invoiceData["totalTaxes"]).map(([key, value]) => (
              <p key={value}>
                <b>
                  {intl.formatNumber(value / 100, {
                    style: "currency",
                    currency: invoiceData["priceCurrency"]
                  })}
                </b>{" "}
                {translate("TVA")} <small>({key / 100}%)</small>
              </p>
            ))}
          </div>
        ) : null}

        <Link to="/">
          <Button secondary label={translate("Revenir à la boutique")} />
        </Link>
      </div>
    )}
  </div>
);

export default CheckoutResponse;



// WEBPACK FOOTER //
// ./src/app/components/CheckoutResponse/CheckoutResponse.js